import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as survey from '../survey'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: survey.RESOURCE.payload.dimension.partialId,
      partialId: survey.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    description: 'Space survey comment',
    isOptional: true,
    name: 'Comment',
    partialId: PartialId.Standard.create('comment'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
